import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

const featuredArticles = articles.filter((a) => a.featured).slice(0, 4);
const latestArticles = articles.slice(0, 6);

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '萝莉次元',
  url: 'https://lolidimension.com',
  description: '专注于二次元萝莉文化的创作与分享平台，汇聚ACG动漫插画、角色设定、同人创作等内容。',
  sameAs: ['https://weibo.com/lolidimension', 'https://space.bilibili.com/lolidimension'],
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '萝莉次元',
  url: 'https://lolidimension.com',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://lolidimension.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '萝莉次元是一个什么样的平台？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '萝莉次元是专注于二次元萝莉文化的创作与分享平台，汇聚ACG动漫插画、角色设定、同人创作等内容，为爱好者提供高质量的交流社区。',
      },
    },
    {
      '@type': 'Question',
      name: '如何在萝莉次元发布自己的作品？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '注册成为萝莉次元会员后，即可在社区发布您的原创萝莉插画、角色设定和同人作品。发布时请选择合适的分类并添加标签。',
      },
    },
    {
      '@type': 'Question',
      name: '萝莉次元的内容审核标准是什么？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们鼓励原创、尊重版权、友好交流。所有内容需符合社区规范，禁止侵权、色情和暴力内容。引用他人作品请标明出处。',
      },
    },
  ],
};

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <JsonLd data={organizationSchema} />
      <JsonLd data={websiteSchema} />
      <JsonLd data={faqSchema} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        {/* Hero Section */}
        <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20dreamy%20and%20artistic%20anime-style%20illustration%20with%20soft%20pastel%20pink%20and%20cream%20background%2C%20featuring%20floating%20cherry%20blossom%20petals%2C%20sparkling%20magical%20particles%2C%20soft%20bokeh%20lights%2C%20ethereal%20and%20fantasy%20atmosphere%2C%20gentle%20gradient%20from%20warm%20pink%20to%20cream%20white%2C%20no%20characters%2C%20abstract%20and%20elegant%20composition%2C%20high%20quality%20digital%20art&width=1800&height=900&seq=hero-bg-2026-loli&orientation=landscape"
            alt="萝莉次元 - 二次元萝莉文化聚集地"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
          <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4">
            <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center mb-6">
              <i className="ri-heart-pulse-line text-primary-300 text-5xl md:text-6xl"></i>
            </div>
            <h1 className="font-heading text-3xl md:text-5xl text-white mb-4 text-center">
              萝莉次元
            </h1>
            <p className="text-white/80 text-sm md:text-lg max-w-xl text-center leading-relaxed">
              专注于二次元萝莉文化的创作与分享平台，汇聚ACG动漫插画、角色设定、同人创作等内容，带你深入探索萝莉次元的无限魅力与创意世界。
            </p>
            <div className="flex flex-col sm:flex-row gap-3 mt-8">
              <Link
                to="/category/illustration"
                className="px-6 py-3 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                探索内容
              </Link>
              <Link
                to="/about"
                className="px-6 py-3 bg-white/20 backdrop-blur-sm text-white border border-white/30 rounded-full text-sm font-medium hover:bg-white/30 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                关于我们
              </Link>
            </div>
          </div>
        </section>

        {/* Category Grid */}
        <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
              探索内容分类
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
              五大内容板块，满足你对二次元萝莉文化的所有想象
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group bg-background-50 border border-background-200/70 rounded-lg p-5 hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3 group-hover:bg-primary-200 transition-colors">
                  <i className={`${cat.icon} text-lg`}></i>
                </div>
                <h3 className="font-heading text-base text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
              </Link>
            ))}
          </div>
        </section>

        {/* Featured Articles */}
        <section className="w-full bg-background-100 py-10 md:py-14">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
                  精选文章
                </h2>
                <p className="text-sm text-foreground-600">
                  编辑精选的高品质内容推荐
                </p>
              </div>
              <Link
                to="/category/illustration"
                className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                查看全部
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {featuredArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
                >
                  <div className="relative w-full h-44 overflow-hidden">
                    <img
                      src={article.imageUrl}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-4">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-full whitespace-nowrap">
                        {categories.find((c) => c.slug === article.category)?.name || article.category}
                      </span>
                      <span className="text-xs text-foreground-400 whitespace-nowrap">{article.readTime}</span>
                    </div>
                    <h3 className="font-heading text-sm text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                      {article.excerpt}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Latest Articles */}
        <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
                最新内容
              </h2>
              <p className="text-sm text-foreground-600">
                社区创作者们的最新作品与分享
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {latestArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group flex gap-4 bg-background-50 border border-background-200/70 rounded-lg p-4 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="w-20 h-20 md:w-24 md:h-24 flex-shrink-0 rounded-lg overflow-hidden">
                  <img
                    src={article.thumbnailUrl}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{article.date}</span>
                    <span className="text-xs text-foreground-300">·</span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{article.readTime}</span>
                  </div>
                  <h3 className="font-heading text-sm text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 line-clamp-1">
                    {article.excerpt}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </section>

        {/* Community CTA */}
        <section className="relative w-full py-14 md:py-20 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Soft%20dreamy%20anime%20style%20background%20with%20gentle%20pink%20and%20peach%20gradient%2C%20floating%20sparkle%20particles%2C%20ethereal%20magical%20atmosphere%2C%20soft%20light%20rays%2C%20abstract%20fantasy%20composition%2C%20warm%20and%20inviting%20mood&width=1800&height=600&seq=cta-bg-loli&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/35"></div>
          <div className="relative z-10 max-w-2xl mx-auto text-center px-4">
            <h2 className="font-heading text-2xl md:text-4xl text-white mb-4">
              加入萝莉次元，开启创作之旅
            </h2>
            <p className="text-white/80 text-sm md:text-base mb-8 leading-relaxed">
              在这里，你将遇见志同道合的二次元伙伴，分享你的创作，发现更多精彩内容。萝莉次元，因你而更加美好。
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-3">
              <Link
                to="/category/illustration"
                className="px-8 py-3 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                开始探索
              </Link>
              <Link
                to="/about"
                className="px-8 py-3 bg-white/20 backdrop-blur-sm text-white border border-white/30 rounded-full text-sm font-medium hover:bg-white/30 transition-colors whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}